export default __webpack_public_path__ + "static/sMNT-97955643f23d5f34d8fc28b3c4bbf017.svg";